<template>
  <div class="menu">
    <div class="statusBar" >
      <br>
      <div>
        <div class="containerbtn">
          <div class="radio-tile-group">
            <div class="input-container" >
              <input id="bike" class="radio-button" type="radio" name="radio" @click="getSeven()"/>
              <!-- <input id="bike" class="radio-button" type="radio" name="radio"/> -->
              <div class="radio-tile">
                <!-- <div class="icon bike-icon">
                  <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path d="M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"/>
                  </svg>
                </div> -->
                <label for="bike" class="radio-tile-label">7天足跡</label>
              </div>
            </div>

            <div class="input-container" >
              <input id="drive" class="radio-button1" type="radio" name="radio" @click="getForteen()"/>
              <!-- <input id="drive" class="radio-button1" type="radio" name="radio"/> -->
              <div class="radio-tile">
                <!-- <div class="icon car-icon">
                  <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
                    <path d="M0 0h24v24H0z" fill="none"/>
                  </svg>
                </div> -->
                <label for="drive" class="radio-tile-label">28天足跡</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br><br>
      <hr>
    </div>
    <div class="container" id="container">
      <div class="dia" v-if="record.length === 0 && tempRecord.length === 0">
        <div style="transform: scale(4); width: 50px; height: 20px;margin: 35px auto; margin-top: 60px; color: #526488;">
          <i class="cubeic-warn"></i><br><br>
        </div>
        <br>
        <span style="color: #526488; opacity: 1;">目前無記錄</span>
      </div>
    </div>
    <div class="loading">
      <div class="ball"></div>
      <div class="ball"></div>
      <div class="ball"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapMutations, mapGetters, mapActions } from 'vuex'
import counter from '@/components/data/counter.json'
var date = new Date();
var sevendate =  new Date(date.getTime() - 7 * 24 * 3600 * 1000);
var forteendate =  new Date(date.getTime() - 28 * 24 * 3600 * 1000);
var year = date.getFullYear().toString();
var month = (date.getMonth() + 1) < 10 ? `0${(date.getMonth() + 1).toString()}` : (date.getMonth() + 1).toString();
var nowmonth = (sevendate.getMonth() + 1) < 10 ? `0${(sevendate.getMonth() + 1).toString()}` : (sevendate.getMonth() + 1).toString();
var oneMonth = (forteendate.getMonth() + 1) < 10 ? `0${(forteendate.getMonth() + 1).toString()}` : (forteendate.getMonth() + 1).toString();
var day = date.getDate() < 10 ? `0${date.getDate().toString()}` : date.getDate().toString();
var sevenDays = sevendate.getDate() < 10 ? `0${sevendate.getDate().toString()}` : sevendate.getDate().toString();
var forteenDays = forteendate.getDate() < 10 ? `0${forteendate.getDate().toString()}` : forteendate.getDate().toString();
var localeDate = `${year}${month}${day}`;
var localeDate7 =  `${year}${nowmonth}${sevenDays}`;
var localeDate28 = `${year}${oneMonth}${forteenDays}`;
// console.log(localeDate);
// console.log(localeDate7);
// console.log(localeDate28);
export default {
  data () {
    return {
      // seven: false,
      // forteen: false,
      twoWeeksRecord: [],
      record: [],
      load: false,
      allowCall: true,
      date: '',
      index: 0,
      selectedLabelDefault: '已完成',
      tabs: [{
        label: '',
        C_record: [],
        // icon: 'cubeic-home'
      },
      // {
      //   label: '進行中',
      //   record: [],
      //   // icon: 'cubeic-home'
      // }
      ],
    }
  },
  mounted() {
    if (this.record.length === 0 && this.tempRecord.length === 0) {
      this.getSeven();
      const el = document.querySelector('.radio-button');
      el.checked = true;
    }
    // 已有7天記錄 但 14天=0
    else if (this.tempRecord.length !== 0 && this.twoWeeksRecord.length === 0) {
      this.generateSeven(this.tempRecord)
      const el = document.querySelector('.radio-button');
      el.checked = true;
    }
    // 已有28天記錄 但 7天=0
    else if (this.tempRecord.length === 0 && this.twoWeeksRecord.length !== 0) {
      this.generateForteen(this.twoWeeksRecord)
      const el = document.querySelector('.radio-button1');
      el.checked = true;
    }
    // 28天記錄跟7天記錄同時都有
    else if (this.tempRecord.length !== 0 && this.twoWeeksRecord.length !== 0) {
      this.generateSeven(this.tempRecord)
      const el = document.querySelector('.radio-button');
      el.checked = true;
    }
  },
  computed: {
    ...mapGetters({
      eilisProfile: 'eilisProfile',
      personalData: 'personalData',
      brandData: 'brandData',
      tempRecord: 'tempRecord',
      tempTwoWeeksRecord: 'tempTwoWeeksRecord',
      info: 'info',
    }),
    updateRec: {
      get () { return this.tempRecord },
      set(value) { this.updateRecord({ record: value }); },
    },
    updateTwoWeeks: {
      get () { return this.tempTwoWeeksRecord },
      set(value) { this.updateTwoRecord({ record: value }); },
    },
  },
  methods: {
    ...mapActions({
      getLocationRecord: 'getLocationRecord'
    }),
    ...mapMutations({
      updateRecord: 'updateRecord',
      updateTwoRecord: 'updateTwoRecord'
    }),
    getSeven() {
        this.$loading.show()
        if (this.tempRecord.length !== 0 || this.record.length !== 0) {
          this.$loading.hide()
          return;
        }
        else {
          const container = document.getElementById('container');
          container.innerHTML = '';
          this.getLocationRecord({auth: this.eilisProfile.auth, phone: this.personalData.phone,startDate: localeDate7, endDate: localeDate,})
          .then((res) => {
            this.record = res.data.result.sort((a,b) => b.time - a.time);
            this.updateRec = res.data.result.sort((a,b) => b.time - a.time);
            // this.seven = true;
            // console.log(res);
            this.generateSeven(res.data.result)
            this.$loading.hide()
          })
        }
    },
    getForteen() {
      this.$loading.show()
      // console.log(this.tempTwoWeeksRecord);
      // console.log(this.twoWeeksRecord);
      if (this.tempTwoWeeksRecord.length !== 0 || this.twoWeeksRecord.length !== 0) {
        this.$loading.hide()
        return;
      }
      else {
        const container = document.getElementById('container');
        container.innerHTML = '';
        this.getLocationRecord({auth: this.eilisProfile.auth, phone: this.personalData.phone,startDate: localeDate28, endDate: localeDate,})
        .then((res) => {
          this.twoWeeksRecord = res.data.result.sort((a,b) => b.time - a.time);
          this.updateTwoWeeks = res.data.result.sort((a,b) => b.time - a.time);
          // this.forteen = true;
          // console.log(res);
          this.generateForteen(res.data.result)
          this.$loading.hide()
        })
      }
    },
    generateForteen(val) {
      const container = document.getElementById('container');
      for (let i = 0; i< val.length ;i++) {
        const postElement = document.createElement('div');
        postElement.classList.add('blog-post');
        postElement.innerHTML = `
          <br>
          <ul class="list">
            <div class="item">
              <div class="left">
                <li class="title"> <i class="cubeic-right" style="transform:scale(1.4); background-color: '#526488';"></i> &nbsp&nbsp足跡</li>
              </div>
              <div class="middle">
                <li class="title" style="font-size:15px;">日期:${new Date(val[i].time).toLocaleString()}</li>
              </div>
            </div>
            <div class="item">
              <div class="left">
                <li class="title">店號: ${val[i].shopNo}</li>
                <br>
                <li class="title">門市: ${val[i].shopName}</li>
              </div>
              <div class="middle">
                <li class="entitle"></li>
                <li class="entitle"></li>
              </div>
            </div>
          </ul>
        `;
        container.appendChild(postElement);
      }
    },
    generateSeven(val) {
      const container = document.getElementById('container');
      for (let i = 0; i< val.length ;i++) {
          const postElement = document.createElement('div');
          postElement.classList.add('blog-post');
          postElement.innerHTML = `
            <br>
            <ul class="list">
              <div class="item">
                <div class="left">
                  <li class="title"> <i class="cubeic-right" style="transform:scale(1.4); background-color: '#526488';"></i> &nbsp&nbsp足跡</li>
                </div>
                <div class="middle">
                  <li class="title" style="font-size:15px;">日期:${new Date(val[i].time).toLocaleString()}</li>
                </div>
              </div>
              <div class="item">
                <div class="left">
                  <li class="title">店號: ${val[i].shopNo}</li>
                  <br>
                  <li class="title">門市: ${val[i].shopName}</li>
                </div>
                <div class="middle">
                  <li class="entitle"></li>
                  <li class="entitle"></li>
                </div>
              </div>
            </ul>
          `;
        container.appendChild(postElement);
        // loading.classList.remove('show');
        // this.allowCall = true;
      }
    },
  }
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Open+Sans:300,600&display=swap');

  body {
    font: 300 14px/18px Roboto;
    padding-bottom: 100px;
  }

  .menu {
    z-index: 0;
    padding-left: 0!important;
    padding-right: 0!important;
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    max-width: 540px;
    // height: 650px;
    background-color: #ffffff;
    /* border: 1px solid rgb(170, 170, 170); */
    /* border:1px solid #8a8a8a; */
  }
  .dia {
    font-size: 22px;
    padding: 10px;
    width: 75%;
    max-width: 300px;
    height: 180px;
    border-radius: 10px;
    // border: 1px solid var(--main-color);
    margin: 80px auto;
  }
  .loading {
    z-index: 100;
    display: flex; // 置中
    align-items: center; // 置中
    justify-content: center; // 置中
    margin: 0 auto;
    position: fixed;
    left: 0!important;
    right: 0!important;
    top: 10%;
    color: #111111;
    -webkit-animation-name: myframes;
            animation-name: myframes;
    -webkit-animation-duration: 500ms;
            animation-duration: 500ms;
    -webkit-animation-timing-function: ease-in-out;
            animation-timing-function: ease-in-out;
    border-radius: 5px;
  }
  .top {
    width: 100vw;
    height: 45px ;
    background-color: #ffffffff;
  }
  .top .list{
    text-align: left;
    height: 400px;
    width: 103vw;
  }
  .top  .list .item{
    margin-top: 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    align-content: space-between;
    border-bottom: 2px solid rgba(210, 210, 210, 0.815);
    height: 40px;
    padding: 5px;
  }
  .statusBar {
    // border-bottom: 1px solid var(--main-color);
    z-index: 1000;
    position: fixed;
    font-size: 17px;
    width: 100vw;
    height: 65px ;
    background-color: #ffffffff;
  }

  .container {
    // height: 900px;
    width: 90%;
    min-width: 350px;
    color: black;
    height: calc(100% - 250px);
    margin: 0 auto;
    margin-top: 50px;
    max-width: 600px;
    overflow: auto;
    overflow-y: auto;
    -ms-overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 100px;
  }

  .container .blog-post {
    background-color: #fff;
    box-shadow: 5px 1px 2px rgba(50, 50, 50, .1), 5px 1px 6px 1px rgba(50, 50, 50, .1),
    0px 2px 3px rgba(60, 60, 60, 0.1);
    border-radius: 4px;
    height: 100px;
    padding: 25px;
    margin: 20px 0;
  }
  .container .blog-post .list{
    // margin-top: -25px;
    margin-left: -15px;
    text-align: center;
    height: 100%;
    max-height: 350px;
    width: 85vw;
  }
  .container .blog-post .list .item{
    margin-left: -10px;
    margin-top: -30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    align-content: space-between;
    height: 40px;
    padding: 20px;
    width: 95%;
  }
  .container .blog-post  .list .item .title{
    margin-top: 0px;
    color: rgba(33, 33, 33, 0.851);
    font-size: 16px;
    letter-spacing: 0.3px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
  }
  .container .blog-post .list .item .middle{
    font-size: 13px;
  }
  .entitle{
    text-align: left;
    font-size: 12px;
    color: #21797b;
    margin-top: 0px;
    margin-top: 3px;
  }

  .loading {
    opacity: 0;
    display: flex;
    position: fixed;
    bottom: 50px;
    left: 0%;
    transform: translateX(0%);
    transition: opacity .3s ease-in;
  }

  .loading.show {
    opacity: 1;
  }

  .ball {
    background-color: #777;
    border-radius: 50%;
    margin: 5px;
    height: 10px;
    width: 10px;
    animation: jump .5s ease-in infinite;
  }

  .ball:nth-of-type(2) {
    animation-delay: 0.1s;
  }

  .ball:nth-of-type(3) {
    animation-delay: 0.2s;
  }
  @keyframes myframes1 {
    0% {
      -webkit-transform: scale(0) translateY(200px) rotate(0deg);
            transform: scale(0) translateY(200px) rotate(0deg);
    }
    50% {
      -webkit-transform: scale(0.5) rotate(0deg);
              transform: scale(0.5) rotate(0deg);
    }
    80% {
      -webkit-transform: scale(0.8) rotate(0deg);
              transform: scale(0.8) rotate(0deg);
    }
    100% {
    -webkit-transform: scale(1) translateY(0px) rotate(0deg);
      transform: scale(1) translateY(0px) rotate(0deg);
    }
  }
  @keyframes jump {
    0%, 100% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(-10px);
    }
  }

  $primary-color:  #526488; //   #079ad9;

  .containerbtn {
    position: fixed;
    top: 5px;
    left: 0;
    right: 0;
  }
  .radio-tile-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-left: -35px;
    margin-top: -25px;
    //set dimensions for invisible container
    .input-container {
      position: relative;
      height:  0.5rem;
      width:  8rem;
      margin: 1.9rem;
      @media screen and (max-width: 360px) {
        width: 8rem;
        height: 2rem;
      }

      //make actual radio input invisible
      // + stretch to fill container
      .radio-button {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        margin: 0;
        cursor: pointer;
      }
      .radio-button1 {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        margin: 0;
        cursor: pointer;
      }

      //default tile styles
      .radio-tile {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        border: 2px solid $primary-color;
        // border-radius: 5px;
        padding: 1rem;
        transition: transform 300ms ease;
      }
      .icon svg {
        fill: $primary-color;
        width: 2rem;
        height: 2rem;
      }
      .radio-tile-label {
        text-align: center;
        font-size: 0.9rem;
        font-weight: 600;
        // text-transform: uppercase;
        letter-spacing: 1px;
        color: $primary-color;
      }

      //active tile styles
      .radio-button:checked + .radio-tile {
        background-color: $primary-color;
        border: 2px solid $primary-color;
        color: white;
        transform: scale(1.1, 1.1);
        @media screen and (max-width: 360px) {
          transform: scale(0.9, 0.9);
        }

        .icon svg {
          fill: white;
          background-color: $primary-color;
        }
        .radio-tile-label {
          color: white;
          background-color: $primary-color;
        }
      }

      .radio-button1:checked + .radio-tile {
        background-color: $primary-color;
        border: 2px solid $primary-color;
        color: white;
        transform: scale(1.1, 1.1);
        @media screen and (max-width: 360px) {
          transform: scale(0.9, 0.9);
        }

        .icon svg {
          fill: white;
          background-color: $primary-color;
        }
        .radio-tile-label {
          color: white;
          background-color: $primary-color;
        }
      }
    }
  }
</style>

